import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { HomeModulesUrlv2QueryFragmentDoc } from '../../../onboarded-home/graphql/queries/GetHomeModules.query';
export type GetTvHomeModulesQueryVariables = Types.Exact<{
	fullPath: Types.Scalars['String']['input'];
	site?: Types.InputMaybe<Types.Scalars['String']['input']>;
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	platform?: Types.Platform;
	locale: Types.Scalars['String']['input'];
	watchNowFilter: Types.WatchNowOfferFilter;
	includeUnreleasedEpisodes?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	excludeTextRecommendationTitle?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	includeStandaloneModules?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	withPastEvents?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	withOffers?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	cursor?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetTvHomeModulesQuery = {
	__typename?: 'Query';
	urlV2: {
		__typename: 'Url';
		fullPath: string;
		locale: string;
		objectType: Types.ObjectType;
		heading1?: string | null;
		heading2?: string | null;
		htmlContent?: string | null;
		htmlContentJson?: any | null;
		id: string;
		urlID: number;
		metaDescription?: string | null;
		metaKeywords?: string | null;
		metaRobots?: string | null;
		metaTitle?: string | null;
		hrefLangTags: Array<{ __typename?: 'HrefLangTag'; href: string; hrefLang: string; locale: string }>;
		node:
			| { __typename?: 'Article' }
			| { __typename?: 'Author' }
			| { __typename?: 'Bundle' }
			| { __typename?: 'Device' }
			| { __typename?: 'Episode' }
			| { __typename?: 'GenericTitleList' }
			| { __typename?: 'Genre' }
			| {
					__typename: 'HomePage';
					id: string;
					nextCursor?: number | null;
					modules: Array<
						| {
								__typename: 'HMAVOD';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMArticleTimeline';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMBecauseYouLikedTitle';
								moduleID: number;
								type: string;
								category: string;
								likedTitle:
									| {
											__typename?: 'Movie';
											id: string;
											content: {
												__typename?: 'MovieContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  }
									| {
											__typename?: 'Season';
											id: string;
											content: {
												__typename?: 'SeasonContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  }
									| {
											__typename?: 'Show';
											id: string;
											content: {
												__typename?: 'ShowContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  };
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMCinemaMostAnticipated';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMContinueWatching';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
								titles: Array<{
									__typename?: 'VODTitle';
									availableFrom?: string | null;
									availableTo?: string | null;
									expiry?: string | null;
									playbackProgress?: {
										__typename?: 'PlaybackProgress';
										position: number;
										runtime: number;
									} | null;
									node?:
										| {
												__typename: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
												};
												season: {
													__typename: 'Season';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													content: {
														__typename?: 'SeasonContent';
														title: string;
														fullPath: string;
														seasonNumber: number;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
													};
												};
												show: {
													__typename: 'Show';
													id: string;
													objectType: Types.ObjectType;
													objectId: number;
													content: { __typename?: 'ShowContent'; title: string };
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
										  }
										| {
												__typename: 'Movie';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												content: {
													__typename?: 'MovieContent';
													title: string;
													shortDescription?: string | null;
													originalReleaseYear?: number | null;
													runtime?: number | null;
													fullPath: string;
													posterUrl?: string | null;
													backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
										  }
										| {
												__typename: 'Season';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												content: {
													__typename?: 'SeasonContent';
													title: string;
													shortDescription?: string | null;
													originalReleaseYear?: number | null;
													runtime?: number | null;
													fullPath: string;
													posterUrl?: string | null;
													seasonNumber: number;
													backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												};
												show: {
													__typename: 'Show';
													id: string;
													objectType: Types.ObjectType;
													objectId: number;
													content: { __typename?: 'ShowContent'; title: string };
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
										  }
										| {
												__typename: 'Show';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												content: {
													__typename?: 'ShowContent';
													title: string;
													shortDescription?: string | null;
													originalReleaseYear?: number | null;
													runtime?: number | null;
													fullPath: string;
													posterUrl?: string | null;
													backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
										  }
										| null;
								}>;
						  }
						| {
								__typename: 'HMContinueWatchingJWTV';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<{
									__typename?: 'UserLibraryItem';
									title: string;
									slug: string;
									type: string;
									ownership: string;
									availableFrom?: string | null;
									availableTo?: string | null;
									expiry?: string | null;
									playbackProgress?: {
										__typename?: 'PlaybackProgress';
										position: number;
										runtime: number;
									} | null;
									node?:
										| {
												__typename: 'Movie';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												customlistEntries: Array<{
													__typename?: 'TitleListEntry';
													createdAt: any;
												}>;
												seenlistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												content: {
													__typename?: 'MovieContent';
													title: string;
													shortDescription?: string | null;
													originalReleaseYear?: number | null;
													runtime?: number | null;
													fullPath: string;
													posterUrl?: string | null;
													backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
													genres: Array<{ __typename?: 'Genre'; translation: string }>;
													scoring: {
														__typename?: 'Scoring';
														viral?: number | null;
														imdbScore?: number | null;
														imdbVotes?: number | null;
													};
												};
										  }
										| {
												__typename: 'Show';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												customlistEntries: Array<{
													__typename?: 'TitleListEntry';
													createdAt: any;
												}>;
												seenState: {
													__typename?: 'ShowSeenState';
													seenEpisodeCount: number;
													releasedEpisodeCount: number;
													progress: number;
													caughtUp: boolean;
													lastSeenEpisodeNumber?: number | null;
													lastSeenSeasonNumber?: number | null;
												};
												watchNextEpisode?: {
													__typename?: 'Episode';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													season: {
														__typename?: 'Season';
														id: string;
														content: {
															__typename?: 'SeasonContent';
															fullPath: string;
															posterUrl?: string | null;
														};
														seenState: {
															__typename?: 'ShowSeenState';
															releasedEpisodeCount: number;
															seenEpisodeCount: number;
															progress: number;
														};
													};
													content: {
														__typename?: 'EpisodeContent';
														title: string;
														episodeNumber: number;
														seasonNumber: number;
														upcomingReleases?: Array<{
															__typename?: 'UpcomingRelease';
															releaseDate?: any | null;
															label: Types.UpcomingReleaseLabel;
														}>;
													};
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													show: { __typename?: 'Show'; id: string };
												} | null;
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												content: {
													__typename?: 'ShowContent';
													title: string;
													shortDescription?: string | null;
													originalReleaseYear?: number | null;
													runtime?: number | null;
													fullPath: string;
													posterUrl?: string | null;
													backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
													genres: Array<{ __typename?: 'Genre'; translation: string }>;
													scoring: {
														__typename?: 'Scoring';
														viral?: number | null;
														imdbScore?: number | null;
														imdbVotes?: number | null;
													};
												};
										  }
										| null;
								}>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMFeatureRotator';
								moduleID: number;
								type: string;
								category: string;
								featureRotatorModules: Array<
									| {
											__typename: 'HMAVOD';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMArticleTimeline';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMBecauseYouLikedTitle';
											moduleID: number;
											type: string;
											category: string;
											likedTitle:
												| {
														__typename?: 'Movie';
														id: string;
														content: {
															__typename?: 'MovieContent';
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
														};
												  }
												| {
														__typename?: 'Season';
														id: string;
														content: {
															__typename?: 'SeasonContent';
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
														};
												  }
												| {
														__typename?: 'Show';
														id: string;
														content: {
															__typename?: 'ShowContent';
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
														};
												  };
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMCinemaMostAnticipated';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMContinueWatching';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMContinueWatchingJWTV';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMFeatureRotator';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMHighlightArticle';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMLatestArticles';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMNewPerPackageToday';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMPermanentAudience';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSQTV';
											technicalTags: Array<string>;
											moduleID: number;
											type: string;
											category: string;
											seenTitle:
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  };
											suggestedTitle:
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  };
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSportsLiveFootball';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSportsUpcomingFootball';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlight';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightContinueWatching';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightGoingViral';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightNewOnYourWatchlist';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightNewSimilarToLikedTitle';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightNewWithHighRatings';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightTrendingToday';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMStreamingCharts';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMTVOD';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMTextRecommendation';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMTop3PerPackageToday';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMTop10InYourCountry';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMTopGenre';
											category: string;
											moduleID: number;
											type: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMTopHighlightArticle';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMVideoFeed';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMWatchedBySimilarUsers';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMYoutubeShorts';
											moduleID: number;
											type: string;
											category: string;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| null
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMHighlightArticle';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								article: {
									__typename?: 'Article';
									id: string;
									author: {
										__typename?: 'Author';
										id: string;
										content: {
											__typename?: 'AuthorContent';
											bio: string;
											clearName: string;
											imageUrl?: string | null;
											fullPath: string;
											alumniOf: Array<string>;
											brand: string;
											languagesSpoken: Array<any>;
											occupation: Array<string>;
											publications?: Array<{
												__typename?: 'AuthorSpecificLink';
												name: string;
												url: string;
											}> | null;
											socialHandles?: Array<{
												__typename?: 'AuthorSpecificLink';
												name: string;
												url: string;
											}> | null;
										};
									};
									content: {
										__typename: 'ArticleContent';
										id: number;
										title?: string | null;
										fullPath: string;
										highlightLabel?: string | null;
										highlightTitle?: string | null;
									};
									linkedObjects: Array<{
										__typename?: 'ArticleLinkedObject';
										node:
											| { __typename?: 'Article' }
											| { __typename?: 'Author' }
											| { __typename?: 'Bundle' }
											| { __typename?: 'Device' }
											| { __typename?: 'Episode' }
											| {
													__typename?: 'GenericTitleList';
													id: string;
													followedlistEntry?: {
														__typename?: 'FollowedListEntry';
														createdAt: any;
														name: string;
													} | null;
											  }
											| { __typename?: 'Genre' }
											| { __typename?: 'HomePage' }
											| { __typename?: 'Movie' }
											| { __typename?: 'MultiStepSportEvent' }
											| { __typename?: 'Offer' }
											| { __typename?: 'OfferHistory' }
											| { __typename?: 'Package' }
											| { __typename?: 'Page' }
											| { __typename?: 'Person' }
											| { __typename?: 'ProfileV2' }
											| { __typename?: 'Season' }
											| { __typename?: 'Show' }
											| { __typename?: 'SingleStepSportEvent' }
											| { __typename?: 'SportCompetitionV2' }
											| { __typename?: 'SportCompetitorV2' }
											| { __typename?: 'SportMatch' }
											| { __typename?: 'Url' };
									}>;
								};
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMLatestArticles';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMNewPerPackageToday';
								moduleID: number;
								type: string;
								category: string;
								packagesWithTitles: Array<{
									__typename?: 'PackageTitles';
									package: {
										__typename?: 'Package';
										id: string;
										clearName: string;
										shortName: string;
										packageId: number;
									};
									titlesWithTrend: Array<{
										__typename?: 'TitleWithTrend';
										trend: Types.TitleTrend;
										title:
											| {
													__typename: 'Movie';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													customlistEntries: Array<{
														__typename?: 'TitleListEntry';
														createdAt: any;
													}>;
													seenlistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													content: {
														__typename?: 'MovieContent';
														title: string;
														shortDescription?: string | null;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														scoring: {
															__typename?: 'Scoring';
															viral?: number | null;
															imdbScore?: number | null;
															imdbVotes?: number | null;
														};
													};
											  }
											| {
													__typename: 'Season';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													seenState: {
														__typename?: 'ShowSeenState';
														seenEpisodeCount: number;
														releasedEpisodeCount: number;
														progress: number;
														caughtUp: boolean;
														lastSeenEpisodeNumber?: number | null;
														lastSeenSeasonNumber?: number | null;
													};
													content: {
														__typename?: 'SeasonContent';
														seasonNumber: number;
														title: string;
														shortDescription?: string | null;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														scoring: {
															__typename?: 'Scoring';
															viral?: number | null;
															imdbScore?: number | null;
															imdbVotes?: number | null;
														};
													};
													show: {
														__typename: 'Show';
														id: string;
														objectType: Types.ObjectType;
														objectId: number;
														content: { __typename?: 'ShowContent'; title: string };
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
													};
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
											  }
											| {
													__typename: 'Show';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													customlistEntries: Array<{
														__typename?: 'TitleListEntry';
														createdAt: any;
													}>;
													seenState: {
														__typename?: 'ShowSeenState';
														seenEpisodeCount: number;
														releasedEpisodeCount: number;
														progress: number;
														caughtUp: boolean;
														lastSeenEpisodeNumber?: number | null;
														lastSeenSeasonNumber?: number | null;
													};
													watchNextEpisode?: {
														__typename?: 'Episode';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														season: {
															__typename?: 'Season';
															id: string;
															content: {
																__typename?: 'SeasonContent';
																fullPath: string;
																posterUrl?: string | null;
															};
															seenState: {
																__typename?: 'ShowSeenState';
																releasedEpisodeCount: number;
																seenEpisodeCount: number;
																progress: number;
															};
														};
														content: {
															__typename?: 'EpisodeContent';
															title: string;
															episodeNumber: number;
															seasonNumber: number;
															upcomingReleases?: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
																label: Types.UpcomingReleaseLabel;
															}>;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														show: { __typename?: 'Show'; id: string };
													} | null;
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													content: {
														__typename?: 'ShowContent';
														title: string;
														shortDescription?: string | null;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														scoring: {
															__typename?: 'Scoring';
															viral?: number | null;
															imdbScore?: number | null;
															imdbVotes?: number | null;
														};
													};
											  };
									}>;
								}>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMPermanentAudience';
								category: string;
								moduleID: number;
								type: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSQTV';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSportsLiveFootball';
								moduleID: number;
								type: string;
								category: string;
								events: Array<
									| { __typename?: 'MultiStepSportEvent' }
									| {
											__typename: 'SingleStepSportEvent';
											id: string;
											sport: Types.SportType;
											objectType: Types.ObjectType;
											objectId: number;
											offerCount: number;
											mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename?: 'SportOffer';
												standardWebURL?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												audioLanguage?: string | null;
												sportObjectType: Types.SportObjectType;
												package: {
													__typename?: 'Package';
													clearName: string;
													icon: string;
													iconBlurHash?: string | null;
													id: string;
													packageId: number;
													technicalName: string;
													shortName: string;
													monetizationTypes: Array<Types.MonetizationType>;
													iconWide: string;
												};
											} | null;
											competition?: {
												__typename?: 'SportCompetitionV2';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												sport: Types.SportType;
												content: {
													__typename?: 'SportCompetitionContentV2';
													fullPath: string;
													iconBlurHash?: string | null;
													iconUrl?: string | null;
													name: string;
												};
												activeSeason?: {
													__typename?: 'SportSeason';
													name: string;
													seasonID: number;
												} | null;
											} | null;
											content: {
												__typename?: 'SingleStepSportEventContent';
												endAt?: any | null;
												fullPath?: string | null;
												name: string;
												startAt: any;
												status: Types.SportEventStatus;
												competitionStage: {
													__typename?: 'SportCompetitionStageV2';
													name: Types.SportCompetitionStageName;
													number?: number | null;
												};
												season?: {
													__typename?: 'SportSeason';
													name: string;
													seasonID: number;
												} | null;
												venue?: {
													__typename?: 'SportVenue';
													venueID: number;
													name: string;
												} | null;
												pastEvents?: Array<{
													__typename?: 'SingleStepSportEvent';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													sport: Types.SportType;
													competition?: {
														__typename?: 'SportCompetitionV2';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														sport: Types.SportType;
														content: {
															__typename?: 'SportCompetitionContentV2';
															fullPath: string;
															name: string;
														};
													} | null;
													competitors: {
														__typename?: 'SingleStepSportCompetitorsV2';
														homeTeam: {
															__typename?: 'SingleStepSportCompetitorV2';
															score?: number | null;
															competitors: Array<{
																__typename?: 'SportCompetitorV2';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																sport: Types.SportType;
																content: {
																	__typename?: 'SportCompetitorContentV2';
																	firstName: string;
																	fullPath?: string | null;
																	lastName: string;
																	name: string;
																	iconUrl?: string | null;
																};
															}>;
														};
														awayTeam: {
															__typename?: 'SingleStepSportCompetitorV2';
															score?: number | null;
															competitors: Array<{
																__typename?: 'SportCompetitorV2';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																sport: Types.SportType;
																content: {
																	__typename?: 'SportCompetitorContentV2';
																	firstName: string;
																	fullPath?: string | null;
																	lastName: string;
																	name: string;
																	iconUrl?: string | null;
																};
															}>;
														};
													};
													content: {
														__typename?: 'SingleStepSportEventContent';
														name: string;
														startAt: any;
														status: Types.SportEventStatus;
														season?: {
															__typename?: 'SportSeason';
															name: string;
															seasonID: number;
														} | null;
													};
												}>;
											};
											competitors: {
												__typename?: 'SingleStepSportCompetitorsV2';
												homeTeam: {
													__typename?: 'SingleStepSportCompetitorV2';
													score?: number | null;
													winner: boolean;
													competitors: Array<{
														__typename?: 'SportCompetitorV2';
														id: string;
														objectId: number;
														content: {
															__typename?: 'SportCompetitorContentV2';
															name: string;
															iconUrl?: string | null;
															fullPath?: string | null;
														};
													}>;
												};
												awayTeam: {
													__typename?: 'SingleStepSportCompetitorV2';
													score?: number | null;
													winner: boolean;
													competitors: Array<{
														__typename?: 'SportCompetitorV2';
														id: string;
														objectId: number;
														content: {
															__typename?: 'SportCompetitorContentV2';
															name: string;
															iconUrl?: string | null;
															fullPath?: string | null;
														};
													}>;
												};
											};
											offers?: Array<{
												__typename?: 'SportOffer';
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												audioLanguage?: string | null;
												standardWebURL?: string | null;
												sportObjectType: Types.SportObjectType;
												package: {
													__typename?: 'Package';
													id: string;
													packageId: number;
													technicalName: string;
													clearName: string;
													shortName: string;
													monetizationTypes: Array<Types.MonetizationType>;
												};
											}>;
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSportsUpcomingFootball';
								moduleID: number;
								type: string;
								category: string;
								events: Array<
									| { __typename?: 'MultiStepSportEvent' }
									| {
											__typename: 'SingleStepSportEvent';
											id: string;
											sport: Types.SportType;
											objectType: Types.ObjectType;
											objectId: number;
											offerCount: number;
											mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename?: 'SportOffer';
												standardWebURL?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												audioLanguage?: string | null;
												sportObjectType: Types.SportObjectType;
												package: {
													__typename?: 'Package';
													clearName: string;
													icon: string;
													iconBlurHash?: string | null;
													id: string;
													packageId: number;
													technicalName: string;
													shortName: string;
													monetizationTypes: Array<Types.MonetizationType>;
													iconWide: string;
												};
											} | null;
											competition?: {
												__typename?: 'SportCompetitionV2';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												sport: Types.SportType;
												content: {
													__typename?: 'SportCompetitionContentV2';
													fullPath: string;
													iconBlurHash?: string | null;
													iconUrl?: string | null;
													name: string;
												};
												activeSeason?: {
													__typename?: 'SportSeason';
													name: string;
													seasonID: number;
												} | null;
											} | null;
											content: {
												__typename?: 'SingleStepSportEventContent';
												endAt?: any | null;
												fullPath?: string | null;
												name: string;
												startAt: any;
												status: Types.SportEventStatus;
												competitionStage: {
													__typename?: 'SportCompetitionStageV2';
													name: Types.SportCompetitionStageName;
													number?: number | null;
												};
												season?: {
													__typename?: 'SportSeason';
													name: string;
													seasonID: number;
												} | null;
												venue?: {
													__typename?: 'SportVenue';
													venueID: number;
													name: string;
												} | null;
												pastEvents?: Array<{
													__typename?: 'SingleStepSportEvent';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													sport: Types.SportType;
													competition?: {
														__typename?: 'SportCompetitionV2';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														sport: Types.SportType;
														content: {
															__typename?: 'SportCompetitionContentV2';
															fullPath: string;
															name: string;
														};
													} | null;
													competitors: {
														__typename?: 'SingleStepSportCompetitorsV2';
														homeTeam: {
															__typename?: 'SingleStepSportCompetitorV2';
															score?: number | null;
															competitors: Array<{
																__typename?: 'SportCompetitorV2';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																sport: Types.SportType;
																content: {
																	__typename?: 'SportCompetitorContentV2';
																	firstName: string;
																	fullPath?: string | null;
																	lastName: string;
																	name: string;
																	iconUrl?: string | null;
																};
															}>;
														};
														awayTeam: {
															__typename?: 'SingleStepSportCompetitorV2';
															score?: number | null;
															competitors: Array<{
																__typename?: 'SportCompetitorV2';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																sport: Types.SportType;
																content: {
																	__typename?: 'SportCompetitorContentV2';
																	firstName: string;
																	fullPath?: string | null;
																	lastName: string;
																	name: string;
																	iconUrl?: string | null;
																};
															}>;
														};
													};
													content: {
														__typename?: 'SingleStepSportEventContent';
														name: string;
														startAt: any;
														status: Types.SportEventStatus;
														season?: {
															__typename?: 'SportSeason';
															name: string;
															seasonID: number;
														} | null;
													};
												}>;
											};
											competitors: {
												__typename?: 'SingleStepSportCompetitorsV2';
												homeTeam: {
													__typename?: 'SingleStepSportCompetitorV2';
													score?: number | null;
													winner: boolean;
													competitors: Array<{
														__typename?: 'SportCompetitorV2';
														id: string;
														objectId: number;
														content: {
															__typename?: 'SportCompetitorContentV2';
															name: string;
															iconUrl?: string | null;
															fullPath?: string | null;
														};
													}>;
												};
												awayTeam: {
													__typename?: 'SingleStepSportCompetitorV2';
													score?: number | null;
													winner: boolean;
													competitors: Array<{
														__typename?: 'SportCompetitorV2';
														id: string;
														objectId: number;
														content: {
															__typename?: 'SportCompetitorContentV2';
															name: string;
															iconUrl?: string | null;
															fullPath?: string | null;
														};
													}>;
												};
											};
											offers?: Array<{
												__typename?: 'SportOffer';
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												audioLanguage?: string | null;
												standardWebURL?: string | null;
												sportObjectType: Types.SportObjectType;
												package: {
													__typename?: 'Package';
													id: string;
													packageId: number;
													technicalName: string;
													clearName: string;
													shortName: string;
													monetizationTypes: Array<Types.MonetizationType>;
												};
											}>;
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlight';
								moduleID: number;
								type: string;
								category: string;
								modules: Array<
									| { __typename?: 'HMAVOD' }
									| { __typename?: 'HMArticleTimeline' }
									| { __typename?: 'HMBecauseYouLikedTitle' }
									| { __typename?: 'HMCinemaMostAnticipated' }
									| { __typename?: 'HMContinueWatching' }
									| { __typename?: 'HMContinueWatchingJWTV' }
									| { __typename?: 'HMFeatureRotator' }
									| { __typename?: 'HMHighlightArticle' }
									| { __typename?: 'HMLatestArticles' }
									| { __typename?: 'HMNewPerPackageToday' }
									| { __typename?: 'HMPermanentAudience' }
									| { __typename?: 'HMSQTV' }
									| { __typename?: 'HMSportsLiveFootball' }
									| { __typename?: 'HMSportsUpcomingFootball' }
									| { __typename?: 'HMSpotlight' }
									| {
											__typename: 'HMSpotlightContinueWatching';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightGoingViral';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightNewOnYourWatchlist';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightNewSimilarToLikedTitle';
											moduleID: number;
											type: string;
											category: string;
											likedTitle:
												| {
														__typename?: 'Movie';
														id: string;
														content: {
															__typename?: 'MovieContent';
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
														};
												  }
												| {
														__typename?: 'Season';
														id: string;
														content: {
															__typename?: 'SeasonContent';
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
														};
												  }
												| {
														__typename?: 'Show';
														id: string;
														content: {
															__typename?: 'ShowContent';
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
														};
												  };
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightNewWithHighRatings';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightTrendingToday';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															shortDescription?: string | null;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															genres: Array<{
																__typename?: 'Genre';
																translation: string;
															}>;
															scoring: {
																__typename?: 'Scoring';
																viral?: number | null;
																imdbScore?: number | null;
																imdbVotes?: number | null;
															};
														};
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| { __typename?: 'HMStreamingCharts' }
									| { __typename?: 'HMTVOD' }
									| { __typename?: 'HMTextRecommendation' }
									| { __typename?: 'HMTop3PerPackageToday' }
									| { __typename?: 'HMTop10InYourCountry' }
									| { __typename?: 'HMTopGenre' }
									| { __typename?: 'HMTopHighlightArticle' }
									| { __typename?: 'HMVideoFeed' }
									| { __typename?: 'HMWatchedBySimilarUsers' }
									| { __typename?: 'HMYoutubeShorts' }
									| null
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightContinueWatching';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightGoingViral';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightNewOnYourWatchlist';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightNewSimilarToLikedTitle';
								moduleID: number;
								type: string;
								category: string;
								likedTitle:
									| {
											__typename?: 'Movie';
											id: string;
											content: {
												__typename?: 'MovieContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  }
									| {
											__typename?: 'Season';
											id: string;
											content: {
												__typename?: 'SeasonContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  }
									| {
											__typename?: 'Show';
											id: string;
											content: {
												__typename?: 'ShowContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  };
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightNewWithHighRatings';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightTrendingToday';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMStreamingCharts';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTVOD';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTextRecommendation';
								moduleID: number;
								type: string;
								category: string;
								textRecommendation: {
									__typename: 'TextRecommendation';
									id: string;
									headline?: string | null;
									body: string;
									bodyHTML: string;
									originalHeadline?: string | null;
									originalBody?: string | null;
									originalBodyHTML?: string | null;
									watchIf?: Array<string> | null;
									skipIf?: Array<string> | null;
									customProfileType?: string | null;
									watchedAt: any;
									likeCount: number;
									likedByUser: boolean;
									ownedByUser: boolean;
									updatedAt: any;
									tags?: Array<{
										__typename?: 'Tag';
										technicalName: string;
										translatedName: string;
									}> | null;
									watchedOn?: {
										__typename?: 'Package';
										clearName: string;
										id: string;
										shortName: string;
										technicalName: string;
										packageId: number;
										selected: boolean;
										monetizationTypes: Array<Types.MonetizationType>;
										icon: string;
										isVisibleFilterBar: boolean;
										addonParent?: { __typename?: 'Package'; id: string } | null;
									} | null;
									profile: {
										__typename: 'Profile';
										displayName: string;
										firstName: string;
										lastName: string;
										location?: string | null;
										country: any;
										bio?: string | null;
										avatarUrl?: string | null;
										isComplete: boolean;
										ownedByUser: boolean;
										profileUrl: string;
										profileType: Types.ProfileType;
										contentPersonId?: string | null;
										textRecommendationsCount: number;
										id: string;
										externalUrls?: Array<{
											__typename?: 'ProfileSpecificLink';
											type: Types.ProfileSpecificLinkType;
											name?: string | null;
											url: string;
										}> | null;
									};
									title?:
										| {
												__typename: 'Movie';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												content: {
													__typename?: 'MovieContent';
													title: string;
													posterUrl?: string | null;
													fullPath: string;
													upcomingReleases: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														releaseCountDown?: number | null;
													}>;
													scoring: {
														__typename?: 'Scoring';
														imdbScore?: number | null;
														imdbVotes?: number | null;
														tmdbPopularity?: number | null;
														tmdbScore?: number | null;
														jwRating?: number | null;
														tomatoMeter?: number | null;
														certifiedFresh?: boolean | null;
													};
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												availableTo: Array<{
													__typename?: 'AvailableTo';
													availableToDate: any;
													availableCountDown: number;
												}>;
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												customlistEntries: Array<{
													__typename?: 'TitleListEntry';
													createdAt: any;
												}>;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
										  }
										| {
												__typename: 'Season';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												content: {
													__typename?: 'SeasonContent';
													seasonNumber: number;
													title: string;
													posterUrl?: string | null;
													fullPath: string;
													upcomingReleases: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														releaseCountDown?: number | null;
													}>;
													scoring: {
														__typename?: 'Scoring';
														imdbScore?: number | null;
														imdbVotes?: number | null;
														tmdbPopularity?: number | null;
														tmdbScore?: number | null;
														jwRating?: number | null;
														tomatoMeter?: number | null;
														certifiedFresh?: boolean | null;
													};
												};
												show: {
													__typename: 'Show';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													content: {
														__typename?: 'ShowContent';
														title: string;
														fullPath: string;
													};
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													seenState: { __typename?: 'ShowSeenState'; progress: number };
													tvShowTrackingEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													customlistEntries: Array<{
														__typename?: 'TitleListEntry';
														createdAt: any;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												availableTo: Array<{
													__typename?: 'AvailableTo';
													availableToDate: any;
													availableCountDown: number;
												}>;
												seenState: { __typename?: 'ShowSeenState'; progress: number };
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
										  }
										| {
												__typename: 'Show';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												content: {
													__typename?: 'ShowContent';
													title: string;
													posterUrl?: string | null;
													fullPath: string;
													upcomingReleases: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														releaseCountDown?: number | null;
													}>;
													scoring: {
														__typename?: 'Scoring';
														imdbScore?: number | null;
														imdbVotes?: number | null;
														tmdbPopularity?: number | null;
														tmdbScore?: number | null;
														jwRating?: number | null;
														tomatoMeter?: number | null;
														certifiedFresh?: boolean | null;
													};
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												availableTo: Array<{
													__typename?: 'AvailableTo';
													availableToDate: any;
													availableCountDown: number;
												}>;
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												customlistEntries: Array<{
													__typename?: 'TitleListEntry';
													createdAt: any;
												}>;
												seenState: { __typename?: 'ShowSeenState'; progress: number };
												tvShowTrackingEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
										  };
									video?: {
										__typename?: 'Clip';
										externalId: string;
										name: string;
										provider: Types.ClipProvider;
										publishedAt: any;
										sourceUrl: string;
										streamUrl?: string | null;
									} | null;
								};
								title:
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  };
								authorProfile: {
									__typename: 'ProfileV2';
									id: string;
									content: {
										__typename?: 'ProfileContent';
										displayName: string;
										location?: string | null;
										bio?: string | null;
										avatarUrl?: string | null;
										ownedByUser: boolean;
										profileUrl: string;
										profileType: Types.ProfileType;
										externalUrls?: Array<{
											__typename?: 'ProfileSpecificLink';
											type: Types.ProfileSpecificLinkType;
											name?: string | null;
											url: string;
										}> | null;
									};
								};
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTop3PerPackageToday';
								moduleID: number;
								type: string;
								category: string;
								packagesWithTitles: Array<{
									__typename?: 'PackageTitles';
									package: {
										__typename?: 'Package';
										id: string;
										clearName: string;
										shortName: string;
										packageId: number;
									};
									titlesWithTrend: Array<{
										__typename?: 'TitleWithTrend';
										trend: Types.TitleTrend;
										title:
											| {
													__typename: 'Movie';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													customlistEntries: Array<{
														__typename?: 'TitleListEntry';
														createdAt: any;
													}>;
													seenlistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													content: {
														__typename?: 'MovieContent';
														title: string;
														shortDescription?: string | null;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														scoring: {
															__typename?: 'Scoring';
															viral?: number | null;
															imdbScore?: number | null;
															imdbVotes?: number | null;
														};
													};
											  }
											| {
													__typename: 'Season';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													seenState: {
														__typename?: 'ShowSeenState';
														seenEpisodeCount: number;
														releasedEpisodeCount: number;
														progress: number;
														caughtUp: boolean;
														lastSeenEpisodeNumber?: number | null;
														lastSeenSeasonNumber?: number | null;
													};
													content: {
														__typename?: 'SeasonContent';
														seasonNumber: number;
														title: string;
														shortDescription?: string | null;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														scoring: {
															__typename?: 'Scoring';
															viral?: number | null;
															imdbScore?: number | null;
															imdbVotes?: number | null;
														};
													};
													show: {
														__typename: 'Show';
														id: string;
														objectType: Types.ObjectType;
														objectId: number;
														content: { __typename?: 'ShowContent'; title: string };
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
													};
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
											  }
											| {
													__typename: 'Show';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													customlistEntries: Array<{
														__typename?: 'TitleListEntry';
														createdAt: any;
													}>;
													seenState: {
														__typename?: 'ShowSeenState';
														seenEpisodeCount: number;
														releasedEpisodeCount: number;
														progress: number;
														caughtUp: boolean;
														lastSeenEpisodeNumber?: number | null;
														lastSeenSeasonNumber?: number | null;
													};
													watchNextEpisode?: {
														__typename?: 'Episode';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														season: {
															__typename?: 'Season';
															id: string;
															content: {
																__typename?: 'SeasonContent';
																fullPath: string;
																posterUrl?: string | null;
															};
															seenState: {
																__typename?: 'ShowSeenState';
																releasedEpisodeCount: number;
																seenEpisodeCount: number;
																progress: number;
															};
														};
														content: {
															__typename?: 'EpisodeContent';
															title: string;
															episodeNumber: number;
															seasonNumber: number;
															upcomingReleases?: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
																label: Types.UpcomingReleaseLabel;
															}>;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														show: { __typename?: 'Show'; id: string };
													} | null;
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													content: {
														__typename?: 'ShowContent';
														title: string;
														shortDescription?: string | null;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														scoring: {
															__typename?: 'Scoring';
															viral?: number | null;
															imdbScore?: number | null;
															imdbVotes?: number | null;
														};
													};
											  };
									}>;
								}>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTop10InYourCountry';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTopGenre';
								category: string;
								moduleID: number;
								type: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTopHighlightArticle';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								article: {
									__typename?: 'Article';
									id: string;
									author: {
										__typename?: 'Author';
										id: string;
										content: {
											__typename?: 'AuthorContent';
											bio: string;
											clearName: string;
											imageUrl?: string | null;
											fullPath: string;
											alumniOf: Array<string>;
											brand: string;
											languagesSpoken: Array<any>;
											occupation: Array<string>;
											publications?: Array<{
												__typename?: 'AuthorSpecificLink';
												name: string;
												url: string;
											}> | null;
											socialHandles?: Array<{
												__typename?: 'AuthorSpecificLink';
												name: string;
												url: string;
											}> | null;
										};
									};
									content: {
										__typename: 'ArticleContent';
										id: number;
										title?: string | null;
										fullPath: string;
										highlightLabel?: string | null;
										highlightTitle?: string | null;
									};
									linkedObjects: Array<{
										__typename?: 'ArticleLinkedObject';
										node:
											| { __typename?: 'Article' }
											| { __typename?: 'Author' }
											| { __typename?: 'Bundle' }
											| { __typename?: 'Device' }
											| { __typename?: 'Episode' }
											| {
													__typename?: 'GenericTitleList';
													id: string;
													followedlistEntry?: {
														__typename?: 'FollowedListEntry';
														createdAt: any;
														name: string;
													} | null;
											  }
											| { __typename?: 'Genre' }
											| { __typename?: 'HomePage' }
											| { __typename?: 'Movie' }
											| { __typename?: 'MultiStepSportEvent' }
											| { __typename?: 'Offer' }
											| { __typename?: 'OfferHistory' }
											| { __typename?: 'Package' }
											| { __typename?: 'Page' }
											| { __typename?: 'Person' }
											| { __typename?: 'ProfileV2' }
											| { __typename?: 'Season' }
											| { __typename?: 'Show' }
											| { __typename?: 'SingleStepSportEvent' }
											| { __typename?: 'SportCompetitionV2' }
											| { __typename?: 'SportCompetitorV2' }
											| { __typename?: 'SportMatch' }
											| { __typename?: 'Url' };
									}>;
								};
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMVideoFeed';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMWatchedBySimilarUsers';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												shortDescription?: string | null;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												genres: Array<{ __typename?: 'Genre'; translation: string }>;
												scoring: {
													__typename?: 'Scoring';
													viral?: number | null;
													imdbScore?: number | null;
													imdbVotes?: number | null;
												};
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMYoutubeShorts';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| null
					>;
			  }
			| { __typename?: 'Movie' }
			| { __typename?: 'MultiStepSportEvent' }
			| { __typename?: 'Offer' }
			| { __typename?: 'OfferHistory' }
			| { __typename?: 'Package' }
			| { __typename?: 'Page' }
			| { __typename?: 'Person' }
			| { __typename?: 'ProfileV2' }
			| { __typename?: 'Season' }
			| { __typename?: 'Show' }
			| { __typename?: 'SingleStepSportEvent' }
			| { __typename?: 'SportCompetitionV2' }
			| { __typename?: 'SportCompetitorV2' }
			| { __typename?: 'SportMatch' }
			| { __typename?: 'Url' };
	};
};

export const GetTvHomeModulesDocument = gql`
	query GetTVHomeModules(
		$fullPath: String!
		$site: String
		$country: Country!
		$language: Language!
		$platform: Platform! = WEB
		$locale: String!
		$watchNowFilter: WatchNowOfferFilter!
		$includeUnreleasedEpisodes: Boolean = false
		$excludeTextRecommendationTitle: Boolean = false
		$includeStandaloneModules: Boolean = false
		$withPastEvents: Boolean = true
		$withOffers: Boolean = true
		$cursor: Int
	) {
		...homeModulesURLV2Query
	}
	${HomeModulesUrlv2QueryFragmentDoc}
`;
